const OWNER = 'OWNER'
const ADMIN = 'ADMIN'
const USER = 'USER'

export const ORDERED_ROLES = [USER, ADMIN, OWNER]

export const genderKod = {
    1: 'female',
    2: 'male',
}

export const familyStatuses = {
    1: 'single',
    2: 'married',
    3: 'divorced',
    4: 'widow',
}

export const occupations = ['finance']
